export enum PaymentConfigTypeEnum {
  FIXED = "fixed",
  OPEN = "open",
}
